import { useNavigate } from "react-router-dom";
import { logout, showLogout } from "../../services/logout-service";

import { LogoutPresentational } from "./LogoutPresentational";

export const LogoutContainer = () => {
  const navigate = useNavigate();
  const doLogout = async () => {
    await showLogout();
    await logout();
    navigate("/start");
  };

  return <LogoutPresentational logout={() => void doLogout()} />;
};
